export default __webpack_public_path__ + "static/media/background.039298cf.png";